import { ref } from 'vue'
import { defineStore } from 'pinia'
import interopluapi from "@/api/interopluapi"

export const useInteropLuStore = defineStore('interopLu', () => {
  const interopLuData = ref('')  
  async function setInteropLuData() {
    const data = await interopluapi.getLuData();
    interopLuData.value = data
  }

  //Return
  return {
    interopLuData,
    setInteropLuData,
  }
})
